import React from 'react'
import { useStore } from '../../UploadChannelPkg/store'
import DialogSuccessMatchList from 'pureComponents/DialogSuccessMatchList'
import DialogApkMatchList from 'pureComponents/DialogApkMatchList'

const useUploadConfirm = props => {
    const [store, dispatch] = useStore()
    const { dialogType } = props
    const { pkgExistStatus } = store
    const { exist, notExist } = pkgExistStatus
    const existNames = Object.keys(exist)
    const existLength = existNames.length
    const notExistNames = Object.keys(notExist)
    const notExistLength = notExistNames.length

    const handleDeletePkg = channelName => {
        dispatch({ type: 'PkgExistStatusDelete', data: { value: [channelName], field: 'exist' } })
    }

    const genExistFileComponent = () => {
        if (dialogType === 'multiReplace') {
            return <DialogSuccessMatchList data={exist} onDelete={handleDeletePkg} />
        } else {
            return <DialogApkMatchList data={exist} />
        }
    }
    const genNotExistFileComponent = () => {
        return <DialogApkMatchList data={notExist} />
    }

    return { genExistFileComponent, genNotExistFileComponent, existLength, notExistLength, notExistNames }
}

export default useUploadConfirm
